<!--
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-06-19 10:21:52
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2023-08-11 09:53:42
 * @FilePath: \deal\src\index.vue
 * @Description: 设置头部组件刷新
-->
<template>
  <div id="app">
    <main-navbar v-if="reloadHead"></main-navbar>
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { getLang } from '@/assets/utils/common.js'
import MainNavbar from   '@/components/bar/main-navbar.vue'

export default {
  components: {
    MainNavbar
  },
  name: 'App',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  provide() {
        return {
            reloadAll: this.reloadAll
        }
    },
    data() {
        return {
          reloadHead: true
        }
    },
  created () {
    getLang('zh-CN')
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    i18nHandle (val) {
      document.querySelector('html').setAttribute('lang', val)
    },
    reloadAll() {
            this.reloadHead = false
            this.$nextTick(() => {
                this.reloadHead = true
            })
        }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/theme.scss';

#app {
  font-size: 14px;
}
</style>
